<template src="./templates/QuickFilters.html" />

<script setup>

import {
    useCategoriesStore,
} from '@timezoneone/dottie-client-jam';

import TopLevelQuickFilters from './TopLevelQuickFilters.vue';
import IconRenderer from './IconRenderer.vue';

const categoriesStore = useCategoriesStore();

const quickFilterClick = (category) => {

    // Reset the chosen top level category if the user clicks on a quick filter
    // that is not within the current top level category
    if (category.parentId !== categoriesStore.chosenTopLevelCategory) {

        categoriesStore.setChosenTopLevelCategory(null);

    }

};

</script>
